import React from 'react'
import PropTypes from 'prop-types'
import Router from 'next/router'
import Overflow from 'components/Overflow'
import addTestId from 'utils/lib/addTestId'

class Menu extends React.PureComponent {
    render() {
        const { 
            item, 
            handleEdit,
            //handleDelete, 
            //handleArchive 
        } = this.props

        return (
            < Overflow
                inTable
                icon={< span className={'icon-icon_overflow'} />}
                data-testid={addTestId('products-overflow')}
            >
                <Overflow.Option onClick={() => handleEdit(item)}>Edit</Overflow.Option>
                {/* <Overflow.Option onClick={() => handleArchive(item)}>Archive</Overflow.Option> */}
                {/* <Overflow.Option onClick={() => handleDelete(item)}>Delete</Overflow.Option> */}
            </Overflow >
        )
    }
}

Menu.propTypes = {
    handleArchive: PropTypes.func,
    handleDelete: PropTypes.func,
    item: PropTypes.object,
}

export default Menu
